let SELECTOR_BALLOONS = null;
const CLASSNAME_CLICKED = 'balloon-clicked';
let balloonElements = [];
let Balloons = [];

let lastTime = performance.now();
let animationFrameId = null;

const MQ_BALLOONS = window.matchMedia("(min-width: 768px)");
let balloonsActive = false;

const baseBalloonState = {
    state: 'floating', // floating | released | respawning
    anchorX: 0,
    anchorY: 0,
    x: 0,
    y: 0,
    rotation: 0,

    releaseVX: 0,
    releaseVY: 0,
    releaseDrag: 0.985,

    baseTranslateX: 0,
    baseTranslateY: 0,
    baseRotation: 0,

    releaseBaseX: 0, // set on release to track the starting point of the escape motion
    releaseBaseRotation: 0, // set on release to allow the balloon to normalize back to its original rotation over time
    releaseRenderRotation: 0, // the actual rotation applied during rendering, which combines the base rotation with the release wobble
    releaseStartRotation: 0, // the rotation at the moment of release, used as a reference for calculating the release spin
    releaseRotationDirection: 1,

    respawnAt: 0,
    isReentering: false,

    releaseNormalizeDuration: 0.6,
};

function getAlignment( element ) {
    const rect = element.getBoundingClientRect();
    const elementCenterX = rect.left + (rect.width / 2);
    const viewportCenterX = window.innerWidth / 2;

    return elementCenterX < viewportCenterX ? 'left' : 'right';
}

function getBaseTransform( element ) {
    const styles = getComputedStyle( element );

    return {
        baseTranslateX: parseFloat(styles.getPropertyValue('--balloon-base-x')) || 0,
        baseTranslateY: parseFloat(styles.getPropertyValue('--balloon-base-y')) || 0,
        baseRotation: parseFloat(styles.getPropertyValue('--balloon-base-rot')) || 0,
        baseScaleX: parseFloat(styles.getPropertyValue('--balloon-base-scale-x')) || 1,
    };
}

function releaseBalloon(balloon ) {
    // console.log( "Releasing balloon", { element: balloon } );
    balloon.state = 'released';
    balloon.releasedAt = performance.now();

    // capture the rotation direction
    const floatT = (performance.now() - balloon.spawnTime) / 1000;
    const floatPhase = (floatT * 0.9) + balloon.phase;

    // derivative of sin(...) is cos(...)
    balloon.releaseRotationDirection = Math.cos(floatPhase) >= 0 ? 1 : -1;

    // seed the escape motion
    balloon.releaseVX = balloon.side === 'left'
        ? (20 + Math.random() * 10)
        : (-20 - Math.random() * 10);

    balloon.releaseVY = -(140 + Math.random() * 40);
    balloon.releaseDrag = 0.985;

    balloon.releaseBaseX = balloon.x;
    balloon.releaseBaseRotation = balloon.baseRotation + balloon.rotation;
    balloon.releaseStartRotation = balloon.rotation;
}

function renderBalloon( balloon ) {
    const { element, baseTranslateX, baseTranslateY, baseRotation, x, y } = balloon;

    const renderX = baseTranslateX + x;
    const renderY = baseTranslateY + y;

    const renderRotation = balloon.state === 'released'
        ? balloon.releaseRenderRotation
        : baseRotation + balloon.rotation;

    const renderScaleX = balloon.baseScaleX || 1;

    element.style.transform =
        `translate(${renderX}px, ${renderY}px) rotate(${renderRotation}deg) scaleX(${renderScaleX})`;
}
function renderToDOM() {
    // Apply the calculated positions and rotations to the balloon elements
    Balloons.forEach( renderBalloon );
}

function startRespawn( balloon ) {
    balloon.state = 'respawning';
    balloon.respawnAt = performance.now() + 1500 + (Math.random() * 1500);
    balloon.element.classList.remove( CLASSNAME_CLICKED );
}

function updateFloatingBalloon( balloon ) {
    const t = (performance.now() - balloon.spawnTime) / 1000;
    const phase = balloon.phase;

    const driftX =
        Math.sin((t * 0.8) + phase) * 12 +
        Math.sin((t * 1.7) + (phase * 0.7)) * 5;

    const driftY =
        Math.cos((t * 0.6) + (phase * 1.2)) * 10 +
        Math.sin((t * 1.3) + phase) * 4;

    const driftRotation =
        Math.sin((t * 0.9) + phase) * balloon.floatRotation;

    balloon.x = balloon.anchorX + driftX;
    balloon.y = balloon.anchorY + driftY;
    balloon.rotation = driftRotation;
}

function updateReleasedBalloon( balloon, deltaTime ) {
    const now = performance.now();
    const t = (now - balloon.releasedAt) / 1000;

    balloon.y += balloon.releaseVY * deltaTime;
    balloon.releaseVY -= 8 * deltaTime;

    balloon.releaseBaseX += balloon.releaseVX * deltaTime;
    balloon.releaseVX *= balloon.releaseDrag;
    balloon.releaseVX += Math.sin(now / 700 + balloon.phase) * 2 * deltaTime;

    const swayRamp = Math.min(1, t / 0.8);
    const swayX = Math.sin((t * balloon.swaySpeed) + balloon.phase)
        * balloon.swayAmount
        * swayRamp;

    balloon.x = balloon.releaseBaseX + swayX;

    // const normalizeProgress = Math.min(1, t / 0.6); // too mechanical
    const normalizeDelay = 0.05;
    const normalizeDuration = balloon.releaseNormalizeDuration || 0.6;

    const normalizeT = Math.max(0, t - normalizeDelay);
    const normalizeProgress = Math.min(1, normalizeT / normalizeDuration);
    // const normalizedBaseRotation = balloon.releaseBaseRotation * (1 - normalizeProgress);// too mechanical
    const easedNormalizeProgress = 1 - Math.pow(1 - normalizeProgress, 3);
    const normalizedBaseRotation =
        balloon.releaseBaseRotation * (1 - easedNormalizeProgress);

    const wobbleRamp = Math.min(1, Math.max(0, (t - 0.12) / 0.35));
    const wobblePhaseOffset = balloon.releaseRotationDirection > 0
        ? -Math.PI / 2
        : Math.PI / 2;
    const wobble = Math.sin(
        (t * balloon.wobbleSpeed) + balloon.phase + wobblePhaseOffset
    ) * 6 * wobbleRamp;
    const carryRotation = balloon.releaseStartRotation * (1 - wobbleRamp);

    balloon.releaseRenderRotation = normalizedBaseRotation + carryRotation + wobble;
    const rect = balloon.element.getBoundingClientRect();
    if (rect.bottom < 0) {
        startRespawn(balloon);
    }
}

function updateRespawningBalloon( balloon, deltaTime ) {
    const now = performance.now();

    if (!balloon.isReentering) {
        if (now < balloon.respawnAt) return;

        balloon.isReentering = true;
        balloon.x = balloon.side === 'left'
            ? -balloon.element.offsetWidth - 100
            : window.innerWidth + 100;

        balloon.y = balloon.anchorY + 400;
        balloon.rotation = 0;
    }

    const enterSpeed = 3.5;

    balloon.x += (balloon.anchorX - balloon.x) * enterSpeed * deltaTime;
    balloon.y += (balloon.anchorY - balloon.y) * enterSpeed * deltaTime;
    balloon.rotation += (0 - balloon.rotation) * 4 * deltaTime;

    const closeEnough =
        Math.abs(balloon.x - balloon.anchorX) < 2 &&
        Math.abs(balloon.y - balloon.anchorY) < 2;

    if (closeEnough) {
        balloon.x = balloon.anchorX;
        balloon.y = balloon.anchorY;
        balloon.state = 'floating';
        balloon.spawnTime = performance.now();
        balloon.phase = Math.random() * Math.PI * 2;
        balloon.isReentering = false;
    }
}

function update( deltaTime ) {
    // do calculations to update state here
    Balloons.forEach((balloon) => {
        switch (balloon.state) {
            case 'floating':
                updateFloatingBalloon(balloon, deltaTime);
                break;
            case 'released':
                updateReleasedBalloon(balloon, deltaTime);
                break;
            case 'respawning':
                updateRespawningBalloon(balloon, deltaTime);
                break;
        }
    });
}

function loop(now) {
    if( !balloonsActive ) {
        return;
    }
    const delta = (now - lastTime) / 1000; // convert ms → seconds
    lastTime = now;

    update(delta);

    renderToDOM();

    animationFrameId = requestAnimationFrame(loop);
}

function onClickBalloon ( event ) {
    const balloonEl = event.target.closest( SELECTOR_BALLOONS );
    if (!balloonEl) return;

    const id = Number(balloonEl.dataset.index);
    const balloon = Balloons[ id ];

    if (!balloon) return;
    if (balloon.state !== 'floating') {
        balloon.element.classList.add( CLASSNAME_CLICKED );
    }

    releaseBalloon(balloon);
}
function initBalloons() {
    if( !Balloons.length ) {
        Balloons = balloonElements.map( (el, index) => {
            const baseTransform = getBaseTransform(el);
            const balloon = {
                ...baseBalloonState,
                ...baseTransform,
                element: el,
                id: index,
                side: getAlignment( el ),
                positionedAncestor: el.offsetParent || document.body,
                phase: Math.random() * Math.PI * 2,
                spawnTime: performance.now(),
                wobbleSpeed: 1.2 + Math.random() * 0.8, // speed
                floatRotation: 1 + Math.random() * 2, // degrees
                swaySpeed: 0.9 + Math.random() * 0.6,
                swayAmount: 10 + Math.random() * 10,
            };
            el.setAttribute( 'data-side', balloon.side );
            el.setAttribute( 'data-index', index );
            return balloon;
        } );
    }
    document.addEventListener('click', onClickBalloon);
    animationFrameId = requestAnimationFrame(loop);
}

function destroyBalloons() {
    if( animationFrameId ) {
        cancelAnimationFrame( animationFrameId );
        animationFrameId = null;
    }
    Balloons.forEach( balloon => {
        balloon.element.style.transform = '';
    } );
    document.removeEventListener('click', onClickBalloon);
}

function startBalloons() {
    if( balloonsActive ) {
        return;
    }
    balloonsActive = true;
    initBalloons();
}

function stopBalloons() {
    if( !balloonsActive ) {
        return;
    }
    balloonsActive = false;
    destroyBalloons();
}

function onMediaChange( event ) {
    // console.log( 'onMediaChange', {event} );
    if( event.matches ){
        startBalloons();
    } else {
        stopBalloons();
    }
}

function init( { selector } = {} ) {
    // console.log( 'balloons!' );
    if( !selector ) {
        console.warn( "No selector provided for InitBalloons" );
        return;
    }
    SELECTOR_BALLOONS = selector;
    balloonElements = [ ...document.querySelectorAll( selector ) ];
    if( !balloonElements.length ) {
        console.warn( `No elements found for selector "${selector}"` );
        return;
    }

    MQ_BALLOONS.addEventListener( 'change', onMediaChange );
    if( MQ_BALLOONS.matches ) {
        startBalloons();
    }

    // console.log( "Balloons initialized", { Balloons } );
}
export { init as InitBalloons };